import React, { ReactNode } from 'react';
import { SvgIconComponent } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

import { LocalizationTypography } from '~components/organisms';

interface EndingRentalInstructionProps {
  Icon: SvgIconComponent;
  subInstruction?: ReactNode;
  defaultText: string;
  textId: string;
}

export const EndingRentalInstruction = ({
  Icon,
  subInstruction,
  defaultText,
  textId,
}: EndingRentalInstructionProps) => {
  return (
    <Stack flexDirection="row" gap={2.5} alignItems="center" minHeight={40}>
      <Icon color="primary" />
      <Stack>
        <LocalizationTypography
          variant="Inter/Subheading-md"
          fontWeight={400}
          textId={textId}
          components={{
            tag1: <Typography variant="Inter/Heading-3" />,
          }}
          defaultText={defaultText}
        />
        {subInstruction}
      </Stack>
    </Stack>
  );
};
